






import { Component, Vue } from 'vue-property-decorator';
import 'animate.css';

@Component
export default class Animation extends Vue {
    public isActive: boolean = false;

    constructor() {
        super();
    }

    public triggerAnimation() {
        const self    = this;
        self.isActive = true;

        setTimeout(() => {
            self.isActive = false;
        }, 1000);
    }
}
